/**
 * Returns same result until the first promise is resolved
 */
export const takeLeading = <T extends (...args: any[]) => ReturnType<T>>(cb: T) => {
  let currentResult: ReturnType<T> | undefined;

  return (...args: Parameters<T>) => {
    if (currentResult) {
      return currentResult;
    }

    const result = cb(...args);

    if (result instanceof Promise) {
      currentResult = result;
      // eslint-disable-next-line promise/prefer-await-to-then
      result.finally(() => (currentResult = undefined));
    }

    return result;
  };
};
